import { SubmissionMethod } from '../common/SubmissionMethod.model';
import {
    ComplianceStatus,
    DeclineReason,
    TprmRequirementType,
    TprmRequirementTypeMultiInstance,
} from '../entity-details';

export interface DeclineReasonPerInstance {
    instances: Record<string, DeclineReason>;
}

export interface VerificationRequest {
    verificationId: string;
    requestId: string | null;
    insuredId: string;
    createdAt: string;
    completedAt: string | null;
    cancelledAt: string | null;
    inputReceivedAt: string | null;
    reasons: { verificationType: ComplianceStatus, coverageType: TprmRequirementType, instanceId?: string | null }[];
    cancelledCoverageTypes: (TprmRequirementType | TprmRequirementTypeMultiInstance)[];
    extractedCoverageTypes: (TprmRequirementType | TprmRequirementTypeMultiInstance)[];
    rprSummary: string | null;
    rprDescription: string | null;
    verificationType: string;
    parentId: string | null;
    verificationRequestStatus: string;
    createdAutomatically: boolean;
    timeoutAt: string | null;
    issuedAt: string;
    declinedCoverageTypes: Record<TprmRequirementType, DeclineReason | DeclineReasonPerInstance>;
    submissionMethod?: SubmissionMethod;
}

export enum VerificationRequestType {
    expiring = 'EXPIRING',
    new = 'NEW',
    nonCompliant = 'NON_COMPLIANT',
    newEntity = 'NEW_ENTITY_BODY',
    compliant = 'COMPLIANT',
}
